/* eslint-disable no-unused-vars */
import TablePagination from "@mui/material/TablePagination";
import * as React from "react";
import swal from "sweetalert";
import {
  CreateCategoryToPropertyMap,
  GetAllCategoryToPropertyMap,
  UpdateCategoryToPropertyMap,
} from "../../../axios";
import {
  AddIcon,
  BreadCrumbs,
  FormTextInput,
  IconButton,
  Modal,
  NodataFound,
  SearchMappingTable,
} from "../../../components";
import LoaderComponent from "../../../components/common/Loader";
import "../../../styles/tablepagination.css";
import { default as Strings, default as strings } from "../../../translations";
import { isAuthorizedFunc } from "../../../utils";
import {
  CREATE_ITEM_CATEGORY_TO_SUB_CATEGORY_MAPPING,
  UPDATE_ITEM_CATEGORY_TO_SUB_CATEGORY_MAPPING,
} from "../../../utils/constants";
import { CreateMappingCategoryPropertyForm } from "../../../forms";

export default function SearchItemCategoryToPropertyMappingPage() {
  const searchTitle =
    Strings["ItemCategoryPropertyMapping.searchMapingPropertyTitle"],
    action = Strings["RoleFunctionMapping.TableHead.action"],
    category = Strings["ItemCategoryPropertyMapping.TableHead.category"],
    property = Strings["ItemCategoryPropertyMapping.TableHead.property"];

  const [isOpen, setIsOpen] = React.useState(false);
  const [clickedBtn, setClickedBtn] = React.useState("");
  const [currentType, setCurrentType] = React.useState({});
  const [errorMessage, setMessage] = React.useState(null);
  const [rows, setRows] = React.useState([]);
  const [uid, setUid] = React.useState();
  const [loading, setLoading] = React.useState(false);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [totalData, setTotalData] = React.useState(null);
  const [isAdd, setAdd] = React.useState(true);
  const [isUpdate, setIsUpdate] = React.useState(true);
  const [searchValue, setSearchValue] = React.useState({
    value: "",
    error: false,
    success: false,
  });

  React.useEffect(() => {
    setAdd(isAuthorizedFunc(CREATE_ITEM_CATEGORY_TO_SUB_CATEGORY_MAPPING));
    setIsUpdate(isAuthorizedFunc(UPDATE_ITEM_CATEGORY_TO_SUB_CATEGORY_MAPPING));
  }, []);

  const paths = [
    { name: strings["MasterConfigurationText"], path: "master-configuration" },
    {
      name: strings["ItemCategoryPropertyMapping"],
      path: "master-configuration/searchitemcategorytopropertymapping",
    },
  ];

  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
  };

  const handleModalClose = () => {
    setIsOpen(false);
    setMessage(null);
  };

  const converter = (rows) => (rows?.length ? rows.map(d => d.name).join(", ") : "");

  const getData = (rows) =>
    rows.map((data) => ({
      id: data.id,
      item_category: data.name || "",
      properties: data.properties ? converter(data.properties) : "",
    }));

  const getAllCategoryToProperty = React.useCallback(() => {
    let isMounted = true;
    setLoading(true);

    GetAllCategoryToPropertyMap(rowsPerPage, page, searchValue.value)
      .then((res) => {
        if (isMounted) {
          setRows(res.data.data);
          setTotalData(res.data.total);
          setLoading(false);
        }
      })
      .catch(() => isMounted && setLoading(false));

    return () => (isMounted = false);
  }, [rowsPerPage, page, searchValue.value]);

  React.useEffect(() => {
    const cleanup = getAllCategoryToProperty();
    return cleanup;
  }, [getAllCategoryToProperty]);

  const createCategoryToProperty = (formData) => {
    setLoading(true);
    CreateCategoryToPropertyMap(formData)
      .then((res) => {
        if (res.status === 200) {
          getAllCategoryToProperty();
          setLoading(false);
          swal("Success!", res.data.message, "success");
          handleModalClose();
        }
      })
      .catch((e) => {
        setLoading(false);
        setMessage(e.response?.data?.message);
      });
  };

  const updateCategoryToProperty = (formData) => {
    setLoading(true);
    UpdateCategoryToPropertyMap(formData)
      .then((res) => {
        if (res.status === 200) {
          getAllCategoryToProperty();
          setLoading(false);
          swal("Success!", res.data.message, "success");
          handleModalClose();
        }
      })
      .catch((e) => {
        setLoading(false);
        setMessage(e.response?.data?.message);
      });
  };

  const selectModal = () => (
    <CreateMappingCategoryPropertyForm
      setMessage={setMessage}
      errorMessage={errorMessage}
      handleResultData={
        clickedBtn === "add" ? createCategoryToProperty : updateCategoryToProperty
      }
      actionType={clickedBtn}
      handleModalClose={handleModalClose}
      initialValue={clickedBtn === "edit" ? currentType : {}}
      uid={uid}
    />
  );

  const handleChangeEdit = (rowData) => {
    const mappedData = {
      ...rowData,
      properties: Array.isArray(rowData?.properties)
        ? rowData?.properties.map((p) => ({
          id: p?.id,
          name: p?.name
        }))
        : typeof rowData?.properties === "string"
          ? rowData.properties
            .split(",")
            .map((prop) => prop.trim())
            .filter((prop) => prop)
            .map((prop) => ({ id: null, name: prop }))
          : [],
    };

    setUid(rowData.id);
    setClickedBtn("edit");
    setCurrentType(mappedData);
    setIsOpen(true);
  };

  const handleSearch = (searchData) => {
    setSearchValue(searchData);
    if (!searchData.value) getAllCategoryToProperty();
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    getAllCategoryToProperty();
  };

  const mapableData = [
    { dataKey: "item_category", title: category },
    { dataKey: "properties", title: property },
    { dataKey: "id", title: action, isAction: true },
  ];

  const searchTableData = getData(rows);

  return (
    <div className="container">
      {loading && <LoaderComponent />}
      <Modal onHandleClose={handleModalClose} isOpen={isOpen}>
        {selectModal()}
      </Modal>
      <div className="row mt-4">
        <div className="col">
          <h3>{searchTitle}</h3>
          <BreadCrumbs pathList={paths} />
        </div>
        {isAdd && (
          <div className="col-auto">
            <span className="addButton">
              <IconButton
                onClick={() => {
                  setClickedBtn("add");
                  setCurrentType({});
                  setIsOpen(true);
                }}
              >
                <AddIcon />
              </IconButton>
            </span>
          </div>
        )}
        <div className="row">
          <div className="col-12">
            <div className="UserbudgetTable">
              <form onSubmit={handleSearchSubmit}>
                <FormTextInput
                  type="text"
                  className="searchBarUser mb-3"
                  placeholder={`Search`}
                  Value={searchValue.value}
                  onChangeText={handleSearch}
                  inputStyle={{ border: "none" }}
                  editable
                />
              </form>

              {rows.length !== 0 ? (
                <>
                  <SearchMappingTable
                    isUpdate={isUpdate}
                    placeholder="Category"
                    data={searchTableData}
                    mapableData={mapableData}
                    searchProp={["item_category", "properties"]}
                    handleChangeEdit={handleChangeEdit}
                  />
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 15]}
                    component="div"
                    count={totalData}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </>
              ) : (
                !loading && (
                  <NodataFound
                    onClick={() => {
                      setClickedBtn("add");
                      setCurrentType({});
                      setIsOpen(true);
                    }}
                  />
                )
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
